module.exports = {"431002001":"人民路街道","431002002":"北湖街道","431002003":"燕泉街道","431002004":"下湄桥街道","431002005":"骆仙街道","431002006":"增福街道","431002007":"郴江街道","431002008":"涌泉街道","431002009":"安和街道","431002010":"石盖塘街道","431002101":"华塘镇","431002102":"鲁塘镇","431002209":"仰天湖瑶族乡","431002210":"保和瑶族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/431002.json
// module id = 1892
// module chunks = 0